export const defaultSettings = {
  theme: "system",
  chatDensity: "comfortable",
  notifications: {
    level: "all",
    sound: true,
    desktop: true,
    email: false,
  },
  privacy: {
    readReceipts: true,
    lastSeen: true,
    onlineStatus: true,
  },
  sound: {
    messageSound: true,
    notificationSound: true,
    callSound: true,
    volume: 1,
  },
}

export function saveSettings(settings) {
  localStorage.setItem("chat-settings", JSON.stringify(settings))
  localStorage.setItem("sound-volume", settings.sound.volume.toString())

  // Apply theme immediately
  applyTheme(settings.theme)

  // Apply chat density
  document.documentElement.style.setProperty(
    "--message-spacing",
    settings.chatDensity === "compact" ? "0.75rem" : "1.5rem",
  )

  // Request notification permission if enabled
  if (settings.notifications.desktop) {
    requestNotificationPermission()
  }
}

export function loadSettings() {
  const saved = localStorage.getItem("chat-settings")
  if (saved) {
    return JSON.parse(saved)
  }
  return defaultSettings
}

export function applyTheme(theme) {
  if (theme === "system") {
    const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
    document.documentElement.classList.toggle("dark", systemTheme === "dark")
  } else {
    document.documentElement.classList.toggle("dark", theme === "dark")
  }

  // Save the theme in localStorage
  const settings = loadSettings()
  settings.theme = theme
  localStorage.setItem("chat-settings", JSON.stringify(settings))
}

export async function requestNotificationPermission() {
  if (!("Notification" in window)) {
    return
  }

  if (Notification.permission !== "granted") {
    await Notification.requestPermission()
  }
}

// Placeholder for playSound function.  Replace with actual implementation.
function playSound(sound) {
  // Implement sound playing logic here.
  console.log(`Playing sound: ${sound}`)
}

export function showNotification(title, body) {
  const settings = loadSettings()

  if (!settings.notifications.desktop) return

  if (Notification.permission === "granted") {
    new Notification(title, {
      body,
      icon: "/app-icon.png",
    })

    if (settings.notifications.sound && settings.sound.notificationSound) {
      playSound("notification")
    }
  }
}

